import { ReactNode, useEffect } from 'react';
import useSamlTestingConnection from './hooks/useSamlTestingConnection';
import { Loader } from '../Routes.style';

export const CheckPendingTestConnection = ({ children }: { children: ReactNode }) => {
  const samlTestStep = window.sessionStorage.getItem('samlTestStep');

  const { flagSamlTestConnectionEnd } = useSamlTestingConnection();

  useEffect(() => {
    if (samlTestStep) {
      // eslint-disable-next-line @typescript-eslint/no-floating-promises
      flagSamlTestConnectionEnd({ testStatus: 'failed' }); // failed saml test
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return samlTestStep ? (
    <Loader dataTestId="loader-check-pending-test-connection" />
  ) : (
    <>{children}</>
  );
};
